import React, { useMemo, useState, useEffect } from "react";
import TableContainer from "./TableContainer";
import "./PinnedContentTableStyles.css";
import moment from "moment";
import { pinnedContentLabels } from "../../../../../constants/constants";
import { ReactComponent as VideoIcon } from "../../../../../assets/icons/video.svg";
import { ReactComponent as ArticleIcon } from "../../../../../assets/icons/article.svg";
import { ReactComponent as AudioIcon } from "../../../../../assets/icons/audio.svg";
import { ReactComponent as TikTokIcon } from "../../../../../assets/icons/tiktok.svg";
import { useDispatch, useSelector } from "react-redux";
import { notify } from "../../../../../util/helpers";
import {
  deletePinnedContentForPatientLogic,
  fetchPatientPCLogic,
} from "../../../../../store/features/patient/pinnedContentSlice";
import ViewPinnedContent from "./ViewPinnedContent";

const FormatComponent = ({ format, text }) => {
  return (
    <td style={{ display: "flex", gap: "4px", textTransform: "capitalize" }}>
      {format?.toLowerCase() === "videos" && <VideoIcon />}
      {format?.toLowerCase() === "article" && <ArticleIcon />}
      {format?.toLowerCase() === "audio" && <AudioIcon />}
      {format?.toLowerCase() === "tiktoks" && <TikTokIcon />}
      {text}
    </td>
  );
};

const CTAComponent = ({ viewPinnedContent, removePin }) => {
  return (
    <td style={{ display: "flex", gap: "8px" }}>
      <button className="cta-button" onClick={viewPinnedContent}>
        View
      </button>
      <button className="cta-button-alt" onClick={removePin}>
        Remove Pin
      </button>
    </td>
  );
};

const PinnedContentTable = (props) => {
  const { patientPinnedContent } = useSelector((state) => state.pinnedContent)
  const { singlePatientData } = useSelector((state) => state.patient);
  const [isModalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState({});
  // const [patientPinnedContent, setPatientPinnedContent] = useState(initialPinnedContent);
  const dispatch = useDispatch();
  const handleViewPinnedContent = (data) => {
    setData(data);
    setModalOpen(true);
  };

  useEffect(() => {
    if (patientPinnedContent.length === 0) {
      props.setData([]);
      props.setFormattedData([]);
    }
  }, [patientPinnedContent]);

  const handleRemovePinnedContent = (cmsID) => {
    const targetIndex = patientPinnedContent.findIndex(
      (element) => element?.identifier === cmsID
    );
    if (targetIndex === -1) {
      notify("Unable to unpin at this time!", "error");
      return;
    }
   

    const target = patientPinnedContent[targetIndex];
    dispatch(deletePinnedContentForPatientLogic(target?.id))
      .then(() => {
        // Immediately update the local state to remove the item
        patientPinnedContent.filter(
          (element) => element?.identifier !== cmsID
        );
        dispatch(fetchPatientPCLogic(singlePatientData?.id));
      })
      .catch((error) => {
        notify("Failed to unpin content!", "error");
      });
  };


  const columns = useMemo(
    () => [
      {
        Header: "Date Pinned",
        accessor: "pinned_at",
        sortType: (a, b) => {
          //console.log(b?.values)
          return (
            new Date(b?.values?.pinned_at) - new Date(a?.values?.pinned_at)
          );
        },
        Cell: ({ cell }) => {
          return (
            <span>
              {cell.value
                ? moment(cell.value, moment.ISO_8601).format(
                    "MMM Do YYYY, h:mma"
                  )
                : "Not Available"}
            </span>
          );
        },
      },
      {
        Header: "Name of Content",
        accessor: (row) => row?.Title || row?.title || "Untitled",
        Cell: ({ cell }) => {
          return <span>{cell.value}</span>;
        },
      },
      {
        Header: "Category",
        accessor: (row) => row?.classification?.Name || row?.classification?.name || "General",
        Cell: ({ cell }) => {
          const val = cell.value || "General";
          const labelKey = val.toLowerCase();
          return (
            <small
              className="pill"
              style={{
                backgroundColor:
                  pinnedContentLabels[labelKey]?.bgColor ||
                  "lightgray",
                color:
                  pinnedContentLabels[labelKey]?.color ||
                  "#333",
              }}
            >
              {val}
            </small>
          );
        },
      },
      {
        Header: "Format",
        accessor: (row) => row?.media_type || row?.mediaType || "Article",
        Cell: ({ cell }) => {
          return <FormatComponent format={cell.value} text={cell.value} />;
        },
      },
      // {
      //   Header: "Views",
      //   // accessor: "modified",
      //   Cell: ({ cell }) => {
      //     return <small>{cell.value}</small>;
      //   },
      // },
      {
        Header: "Action",
        accessor: (d) => d,
        Cell: ({ cell }) => {
          return (
            <CTAComponent
              viewPinnedContent={() => {
                handleViewPinnedContent(cell.value);
              }}
              removePin={() => {
                handleRemovePinnedContent(cell.value?.id);
              }}
            />
          );
        },
      },
    ],
    [props?.data]
  );

  return (
    <>
      <ViewPinnedContent
        modalIsOpen={isModalOpen}
        setIsOpen={setModalOpen}
        data={data}
      />{" "}
      <TableContainer columns={columns} data={props.data} />
    </>
  );
};

export default PinnedContentTable;
